import React, { useEffect, useState } from "react";
import ImageLinks from "../../../assets/Images/ImagesLink";
import Footer from "../../../Footer";
import {
  hide_loader,
  set_buiness_list,
  set_user_details,
  show_loader,
} from "../../../actions/app";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import Signup from "./Signup";
import api_requests from "../../../resources/api_requests";
import _ from "lodash";
import utils from "../../../resources/utils";
import constant from "../../../resources/constant";
import { useNavigate } from "react-router-dom";
import Loader from "../../../modules/Loader";

const PaytmLogin = () => {
  const { is_loading } = useSelector((state) => state.app, shallowEqual);
  const [signup_data, set_signup_data] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();

  function ready(callback) {
    if (window.JSBridge) {
      callback && callback();
    } else {
      document.addEventListener("JSBridgeReady", callback, false);
    }
  }

  const handle_login = () => {
    dispatch(show_loader());
    ready(function () {
      window.JSBridge.call(
        "paytmFetchAuthCode",
        {
          clientId: process.env.REACT_APP_PAYTM_CLIENT_ID,
        },
        function (result) {
          const authId = result?.data?.authId;
          handle_auth_flow(authId);
        }
      );
    });
  };

  const handle_auth_flow = async (authId) => {
    try {
      const res = await api_requests.paytm_auth_code({ authId });
      if (res?.data?.token) {
        utils._storeData(constant.AUTH_TOKEN, res?.data?.token);
        const data = {
          first_name: res?.data?.info?.first_name,
          last_name: res?.data?.info?.last_name,
          email: res?.data?.info?.meta_info?.email,
          mobile: res?.data?.info?.mobile,
        };
        utils._storeData(constant.USER_DETIALS, data);

        dispatch(set_user_details(data));
        dispatch(set_buiness_list(res?.data?.info?.business_info));
        dispatch(hide_loader());
        navigate("/business-select", { replace: true });
      } else {
        set_signup_data(res?.data);
      }
      dispatch(hide_loader());
    } catch (error) {
      dispatch(hide_loader());
    }
  };

  if (!_.isEmpty(signup_data)) return <Signup data={signup_data} />;
  else
    return (
      <>
        {is_loading && <Loader />}
        <div className="min-h-screen px-6 py-6 overflow-hidden max-h-[100vh] justify-center items-center  flex w-full">
          <div
            className="rounded-lg p-6 overflow-auto w-full flex flex-col justify-center items-center "
            style={{
              boxShadow: `0px 0px 8px 0px #A6A6A640`,
            }}
          >
            <p className="font-custom font-semibold text-2xl text-dark_purple">
              Get Started!
            </p>
            <p className="font-custom font-medium text-xs text-dark_gray">
              Login to proceed.
            </p>

            <button
              type="submit"
              onClick={handle_login}
              className="font-custom btn btn-block bg-[#492897] text-semibold text-base text-white cursor-not-allowed rounded-[30px] mt-6"
            >
              Login with
              <img src={ImageLinks.paytm_logo} />
            </button>
          </div>
          <Footer bottom={4} />
        </div>
      </>
    );
};
export default PaytmLogin;
